import React, {useState, useEffect,useContext} from 'react';
import Graphic from "../utils/graphic";

export default function DashboardGraphic(data:any) {

    const wl1_data = {
        labels: data.program,
        datasets: [{
            data: data.wl1,
            backgroundColor:data.bgColor
        }]
    } ;

    const WL1_GRAPHICS = [
        {
            type: "doughnut",
            width: 300,
            height: 160,
            data: { id: 1, ...wl1_data}
        }
    ];

    const wl2_data = {
        labels: data.program,
        datasets: [{
            data: data.wl2,
            backgroundColor:data.bgColor
        }]
    } ;

    const WL2_GRAPHICS = [
        {
            type: "doughnut",
            width: 300,
            height: 160,
            data: { id: 1, ...wl2_data}
        }
    ];

    const wl3_data = {
        labels: data.program,
        datasets: [{
            data: data.wl2,
            backgroundColor:data.bgColor
        }]
    } ;

    const WL3_GRAPHICS = [
        {
            type: "doughnut",
            width: 300,
            height: 160,
            data: { id: 1, ...wl3_data}
        }
    ];

    return (
        <React.Fragment>
            <div className="card-body table-responsive p-0 tablecustome" >
                <div className="col-12">
                    <div className="card-body row">
                        <div className="col-3">
                            <label>WL1</label>
                            {WL1_GRAPHICS.map(graphic => (
                                <React.Fragment key={graphic.data.id}>
                                    <Graphic
                                        type={graphic.type}
                                        width={graphic.width}
                                        height={graphic.height}
                                        data={graphic.data}
                                    />
                                </React.Fragment>
                            ))}
                        </div>
                        <div className="col-1"></div>
                        <div className="col-3">
                            <label>WL2</label>
                            {WL2_GRAPHICS.map(graphic => (
                                <React.Fragment key={graphic.data.id}>
                                    <Graphic
                                        type={graphic.type}
                                        width={graphic.width}
                                        height={graphic.height}
                                        data={graphic.data}
                                    />
                                </React.Fragment>
                            ))}
                        </div>
                        <div className="col-1"></div>
                        <div className="col-3">
                            <label>WL3</label>
                            {WL3_GRAPHICS.map(graphic => (
                                <React.Fragment key={graphic.data.id}>
                                    <Graphic
                                        type={graphic.type}
                                        width={graphic.width}
                                        height={graphic.height}
                                        data={graphic.data}
                                    />
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
   )
}